import {
  validatePresence,
  validateInclusion,
} from 'ember-changeset-validations/validators';
import {
  KnowledgeBaseQaPairCategory,
  KnowledgeBaseQaPairStatus,
} from 'uplisting-frontend/models/ai-knowledge-base-qa-pair';

export const AiKnowledgeBaseQaPairValidation = {
  question: validatePresence({ presence: true }),
  answer: validatePresence({ presence: true }),
  category: validateInclusion({
    list: Object.values(KnowledgeBaseQaPairCategory),
  }),
  status: validateInclusion({
    list: Object.values(KnowledgeBaseQaPairStatus),
  }),
};
